<span class="race-time">
  @if (timeObj.hours > 0) {
    <span class="hours">{{timeObj.hours}}:</span>
  }
  <span class="min-sec">{{timeObj.minutes<10? '0'+timeObj.minutes : timeObj.minutes}}:{{timeObj.seconds<10 ? '0'+timeObj.seconds : timeObj.seconds}}</span>
  <span class="milli-sec">.{{timeObj.milliseconds}}</span>
  <span class="unit">min</span>
</span>
